/**
 * Permission level of the `can_*` fields of a customer document type.
 * The server treats 0–2 as user-level thresholds (user level <= value =>
 * allowed) and `Locked` (3) as "nobody", independent of the user level.
 */
export enum CustomerDocumentTypePermissionLevel {
  Locked = 3
}
